export enum WinType {

    WINDOW,
    FRAME,
    ELECTRON,
    NATIVE_MOBILE
}
